 const WarningIcon: React.FC = () => (
	  <span style={{ display: "inline-flex", alignItems: "center", color: "#E5B42F", marginTop: 1 }}>
	    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
	            <path
	                d="M12 9V13M12 17H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z"
	        stroke="currentColor"
	                strokeWidth="2"
	                strokeLinecap="round"
	                strokeLinejoin="round"
	            />
	        </svg>
	  </span>
 
  );
export default WarningIcon;